import apiClient from './client';

// Public API (no auth required) - for client-facing portal
export const clientPortalPublicAPI = {
  // Get ALL portal data in one request (prevents connection pool exhaustion).
  // Override the shared 10s timeout — the aggregate query genuinely takes
  // 10-15s for large portals on Render. See routes/clientPortal.js GET /:token/all.
  getAll: (accessToken) =>
    apiClient.get(`/client-portal/${accessToken}/all`, { timeout: 60000 }),

  // Get document file URL (for download/viewing)
  getDocumentFileUrl: (accessToken, docId) =>
    `${apiClient.defaults.baseURL}/client-portal/${accessToken}/documents/${docId}/file`,

  // Get currently-live streams (Twitch + YouTube) for one campaign.
  // Reads from cache only — fast.
  getLive: (accessToken, campaignId) =>
    apiClient.get(`/client-portal/${accessToken}/campaigns/${campaignId}/live`),
};

// Admin API (requires auth) - for managing portals
export const clientPortalAdminAPI = {
  // List portals (optionally { view: 'live' | 'archived' | 'all' })
  list: (params) =>
    apiClient.get('/admin/client-portals', { params }),

  // Get unique client names (for creating new portals)
  getClients: () =>
    apiClient.get('/admin/client-portals/clients'),

  // Get a client's campaigns (to pick a campaign scope when creating a portal)
  getClientCampaigns: (clientName) =>
    apiClient.get(`/admin/client-portals/client-campaigns/${encodeURIComponent(clientName)}`),

  // Get single portal
  get: (id) =>
    apiClient.get(`/admin/client-portals/${id}`),

  // Create new portal
  create: (data) =>
    apiClient.post('/admin/client-portals', data),

  // Update portal
  update: (id, data) =>
    apiClient.put(`/admin/client-portals/${id}`, data),

  // Delete portal
  delete: (id) =>
    apiClient.delete(`/admin/client-portals/${id}`),

  // Regenerate access token
  regenerateToken: (id) =>
    apiClient.post(`/admin/client-portals/${id}/regenerate-token`),

  // Upload document
  uploadDocument: (portalId, data) =>
    apiClient.post(`/admin/client-portals/${portalId}/documents`, data),

  // Update document
  updateDocument: (portalId, docId, data) =>
    apiClient.put(`/admin/client-portals/${portalId}/documents/${docId}`, data),

  // Delete document
  deleteDocument: (portalId, docId) =>
    apiClient.delete(`/admin/client-portals/${portalId}/documents/${docId}`),

  // Reorder documents
  reorderDocuments: (portalId, order) =>
    apiClient.post(`/admin/client-portals/${portalId}/documents/reorder`, { order }),
};
